<template></template>
<script>
    export default {
        props: ['messages'],
        data() {
            return {}
        },
        created() {
            window.events.$on(
                'flash', data => this.flash(data)
            )
        },
        mounted() {
            this.messages.forEach(message => this.flash(message))
        },
        methods: {
            flash(data) {
                if(data.undo) {
                    let scoped = require('toastr')
                    scoped.options = window.toastr.options
                    scoped.options.closeButton = true
                    scoped.options.timeOut = 0
                    scoped.options.extendedTimeOut = 0;
                    scoped.success(`<div>${data.message}</div><a class="undo" href="${data.undo_link}">${this.$t('general.action.undo')}</a>`)
                } else {
                    // Delegate to Toastr
                    this[data.level](data)
                }
            },
            success(data) {
                window.toastr.success(data.message)
            },
            error(data) {
                window.toastr.error(data.message)
            },
            warning(data) {
                window.toastr.warning(data.message)
            },
            info(data) {
                window.toastr.info(data.message)
            }
        }
    }
</script>
